export function stableSort<T>(array: readonly T[], comparator: (a: T, b: T) => number) {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
    console.log('stableSort stablizedThis: ', stabilizedThis)
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    console.log('stableSort return: ', stabilizedThis.map((el) => el[0]))
    return stabilizedThis.map((el) => el[0]);
}